export default {
  methods: {
    async callPreCheckThen(onPass, onFail) {
      try {
        const res = await this.$http.get('/api/order/preCheck.do');
        if (res.data.retval !== this.CONSTANT.SUCCESS) {
          this.$store.commit('setSession', null);
          this.$router.push({
            path: "/m/login",
            query: {return_url: this.$route.fullPath}
          }).catch(() => {});
          return;
        }
        if (!res.data.ok) {
          if (typeof onFail === 'function' && onFail(res.data.code, res.data.message) === true) return;
          alert(res.data.message);
          return;
        }
        if (typeof onPass === 'function') await onPass();
      } catch (e) {
        alert("사전 체크에 실패했습니다.");
      }
    }
  }
};


// WEBPACK FOOTER //
// ./src/mixins/callPreCheck.js